import { Injectable } from '@angular/core';
import { CoreQuestionsFactoryService, LocalesService } from 'core/services';
import { BehaviorSubject } from 'rxjs';
import {
  HiddenQuestion,
  QuestionBase,
  QuestionGroup,
  TagsQuestion,
  TextboxQuestion,
  EntityQuestion
} from 'core/components';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class KeplerPlayerDataQuestionsService {
  protected questions: QuestionBase<any>[] = [];
  protected formData: any = {};
  protected form: UntypedFormGroup;
  protected questionsSubject = new BehaviorSubject(null);
  constructor(
    protected factory: CoreQuestionsFactoryService,
    private localesService: LocalesService,
    public translate: TranslateService
  ) {}

  getFormData(): any {}

  onDataChanged(newData: any = {}) {
    this.formData = newData;
  }

  setForm(form: UntypedFormGroup) {
    this.form = form;
  }

  getQuestionsObservable() {
    return this.questionsSubject.asObservable();
  }

  getPlayerStatus(player) {
    if (player.suspended) return this.translate.instant('kepler.player.status.canceled');
    if (!player.firstConnection && !player.suspended) return this.translate.instant('kepler.player.status.pending');
    if (new Date(player.matchEndDate).getTime() < Date.now())
      return this.translate.instant('kepler.player.status.finished');
    return this.translate.instant('kepler.player.status.playing');
  }

  getQuestions(player, client, match) {
    const clientQuestion = this.factory.getClientQuestion({
      client,
      title: 'actions.selectClient',
      class: 'col-1',
      validators: { required: true },
      editable: false,
      order: 1
    });
    return [
      new QuestionGroup({
        title: 'kepler.player.editTitle',
        childQuestions: [
          new HiddenQuestion({
            key: 'id',
            value: player.id
          }),
          clientQuestion,
          new TextboxQuestion({
            key: 'matchName',
            label: 'kepler.player.matchName',
            value: player.matchName,
            editable: false,
            order: 2
          }),
          new TextboxQuestion({
            key: 'name',
            label: 'kepler.player.name',
            value: player.name,
            order: 3
          }),
          new TextboxQuestion({
            key: 'surname',
            label: 'kepler.player.surname',
            value: player.surname,
            order: 4
          }),
          new TextboxQuestion({
            key: 'lang',
            label: 'nouns.language',
            value: player && player.lang ? this.localesService.getLocaleName(player.lang) : null,
            editable: false,
            order: 5
          }),
          new TextboxQuestion({
            key: 'email',
            label: 'kepler.player.email',
            value: player.email,
            editable: false,
            order: 6
          }),
          new TextboxQuestion({
            key: 'status',
            label: 'kepler.player.statusLabel',
            class: 'col-2-offset',
            value: this.getPlayerStatus(player),
            editable: false,
            order: 7
          }),
          new EntityQuestion({
            key: 'group',
            label: 'kepler.player.group',
            value: player.group,
            isLocalEntity: true,
            localEntityData: {
              docs: match.groups.map((group) => {
                return { name: group };
              })
            },
            entityOptions: {
              valueField: 'name',
              preload: ''
            },
            order: 8
          }),
          new EntityQuestion({
            key: 'federation',
            label: 'kepler.player.federation',
            value: player.federation,
            isLocalEntity: true,
            localEntityData: {
              docs: match.federations.map((federation) => {
                return { name: federation };
              })
            },
            entityOptions: {
              valueField: 'name',
              preload: ''
            },
            order: 9
          }),
          new TagsQuestion({
            key: 'tags',
            label: 'kepler.player.tags',
            value: player.tags ? player.tags.filter((playerTag) => playerTag) : player.tags,
            order: 10
          })
        ]
      })
    ];
  }
}
